import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import LineArtBanner from '../assets/img/lineart.svg';
import Logo from '../assets/img/one-real-mortgage-logo.svg';
import Button from '../components/Button';
import useQueryParams from '../hooks/useQueryParams';
import Route404 from './Route404';

const QRCodeRoute: React.FC = () => {
  const { url }: any = useQueryParams();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  if (!url) {
    return <Route404 />;
  }

  const downloadQRCode = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const pngUrl = canvas.toDataURL('image/png');
    const downloadLink = document.createElement('a');
    downloadLink.download = 'onereal-qr-code.png';
    downloadLink.href = pngUrl;
    downloadLink.click();
  };

  return (
    <div className='bg-reskin-midnight-green-900 h-screen w-screen overflow-scroll relative'>
      <img
        src={Logo}
        alt='Logo'
        className='cursor-pointer absolute lg:top-10 top-8 md:left-10 left-5'
      />

      <div className='absolute top-28 right-0'>
        <img src={LineArtBanner} alt='logo' className='w-full' />
      </div>

      <div className='flex flex-col items-center h-full justify-center z-10 relative'>
        <div className='bg-reskin-midnight-green-800 py-8 px-10 rounded-[30px] mx-auto'>
          <div className='text-reskin-aqua text-center font-medium text-2xl mb-8'>
            Lending Partner Page
          </div>
          <QRCodeCanvas
            value={url}
            size={320}
            className='mb-8 p-4 bg-white rounded-lg'
            id='qr-code-canvas'
            ref={canvasRef}
          />
          <div className='flex flex-row justify-center'>
            <Button
              label='Download QR Code'
              variant='seaglass'
              onPress={downloadQRCode}
              buttonSize='xs'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeRoute;
